export default __webpack_public_path__ + "static/net_so-478d4fb669548d980cdb874e8af31c17.svg";